export const filterDtcs = (selectedDtcs, dtcOptions) => {
  const dtcSet = new Set(
    selectedDtcs.map((dtc) =>
      typeof dtc == 'object' ? `${dtc.acronym}-${dtc.dtc}` : dtc,
    ),
  )
  const dtcs = Object.values(dtcOptions)
    .filter((dtc) => dtcSet.has(dtc.label))
    .map((dtc) => dtc.value)

  return dtcs
}
